import {
    GET_SHIPPING_LISTING,
    GET_SHIPPING_LISTING_SUCCESS,
    GET_SHIPPING_LISTING_FAIL,
    GET_SHIPPING_DETAILS,
    GET_SHIPPING_DETAILS_SUCCESS,
    GET_SHIPPING_DETAILS_FAIL,
    ADD_SHIPPING,
    ADD_SHIPPING_SUCCESS,
    ADD_SHIPPING_FAIL,
    UPDATE_SHIPPING,
    UPDATE_SHIPPING_SUCCESS,
    UPDATE_SHIPPING_FAIL,
    DELETE_SHIPPING,
    DELETE_SHIPPING_SUCCESS,
    DELETE_SHIPPING_FAIL,
    EXPORT_SHIPPING,
    EXPORT_SHIPPING_SUCCESS,
    EXPORT_SHIPPING_FAIL,
    RESET_SHIPPING_STATE,
    RESET_SHIPPING_ATTACHMENT_STATE,
} from "./actionTypes";

export const getShippingListing = (shipping) => ({
    type: GET_SHIPPING_LISTING,
    payload: shipping,
});

export const getShippingListingSuccess = shipping => ({
    type: GET_SHIPPING_LISTING_SUCCESS,
    payload: shipping,
});

export const getShippingListingFail = error => ({
    type: GET_SHIPPING_LISTING_FAIL,
    payload: error,
});

export const getShippingDetails = shippingId => ({
    type: GET_SHIPPING_DETAILS,
    payload: shippingId,
});

export const getShippingDetailsSuccess = shipping => ({
    type: GET_SHIPPING_DETAILS_SUCCESS,
    payload: shipping,
});

export const getShippingDetailsFail = error => ({
    type: GET_SHIPPING_DETAILS_FAIL,
    payload: error,
});

export const createShipping = shipping => ({
    type: ADD_SHIPPING,
    payload: shipping,
});

export const createShippingSuccess = shipping => ({
    type: ADD_SHIPPING_SUCCESS,
    payload: shipping,
});

export const createShippingFail = error => ({
    type: ADD_SHIPPING_FAIL,
    payload: error,
});

export const updateShipping = shipping => ({
    type: UPDATE_SHIPPING,
    payload: shipping,
});

export const updateShippingSuccess = shipping => ({
    type: UPDATE_SHIPPING_SUCCESS,
    payload: shipping,
});

export const updateShippingFail = error => ({
    type: UPDATE_SHIPPING_FAIL,
    payload: error,
});

export const deleteShipping = shippingId => ({
    type: DELETE_SHIPPING,
    payload: shippingId,
});

export const deleteShippingSuccess = shippingId => ({
    type: DELETE_SHIPPING_SUCCESS,
    payload: shippingId,
});

export const deleteShippingFail = error => ({
    type: DELETE_SHIPPING_FAIL,
    payload: error,
});

export const exportShipping = data => ({
    type: EXPORT_SHIPPING,
    payload: data
});

export const exportShippingSuccess = data => ({
    type: EXPORT_SHIPPING_SUCCESS,
    payload: data,
});

export const exportShippingFail = error => ({
    type: EXPORT_SHIPPING_FAIL,
    payload: error,
});

//reset
export const resetShippingState = () => {
    return {
        type: RESET_SHIPPING_STATE,
    }
}

//reset attachment
export const resetShippingAttachmentState = () => {
    return {
        type: RESET_SHIPPING_ATTACHMENT_STATE,
    }
}

